import { schema } from "normalizr";
import { wfpOfficesTypes } from "../types";
import Resource from "./resource";

const wfpOfficeSchema = new schema.Entity("wfpOffices");

export default new Resource("/offices", wfpOfficesTypes, wfpOfficeSchema);
